import { makeStyles } from "tss-react/mui"
import { blueGrey, lightBlue } from "../../../../mp-core/themes/palette"
import { inputBaseClasses, outlinedInputClasses } from "@mui/material"

export const useStyles = makeStyles()(
  ({ spacing, palette, transitions, typography, mixins }) => ({
    container: {
      width: "100%"
    },
    icon: {
      color: blueGrey[500]
    },
    input: {
      borderRadius: "3px",
      "& > input": {
        lineHeight: "1.25rem",
        padding: spacing(2, 2, 2, 0),
        height: typography.pxToRem(20),

        "&:placeholder": {
          userSelect: "none"
        }
      },
      fontSize: "0.875rem",
      [`& .${outlinedInputClasses.notchedOutline}`]: {
        transition: transitions.create(["border-color"]),
        borderWidth: "1px",
        borderColor: blueGrey[200],
        top: 0,

        "& > legend": {
          display: "none"
        }
      },
      [`&.${inputBaseClasses.focused}`]: {
        backgroundColor: palette.background.paper,
        boxShadow: mixins.focusRing.shadow.boxShadow,

        [`& .${outlinedInputClasses.notchedOutline}`]: {
          borderColor: `${lightBlue[300]} !important`,
          borderWidth: "1px"
        }
      },
      [`&.${inputBaseClasses.sizeSmall}`]: {
        [`&.${inputBaseClasses.root}`]: {
          paddingLeft: spacing(2)
        },
        "& > input": {
          padding: spacing(1, 2, 1, 0),
          height: typography.pxToRem(22),
          lineHeight: typography.pxToRem(16)
        },
        fontSize: typography.pxToRem(14)
      },
      "& input::placeholder": {
        color: blueGrey[700],
        opacity: 1
      },
      "&:hover": {
        fieldset: {
          borderColor: `${blueGrey[400]} !important`
        }
      }
    }
  })
)
